import React from 'react';
import fx from 'money';
import {MoneyV2} from '@shopify/hydrogen/storefront-api-types';
// import {useLocalization} from '@shopify/hydrogen';
import {GlobalContext} from '../GlobalProvider.client';
const HKExchangeRates = {
  EUR: 0.117315,
  USD: 0.127719,
  HKD: 1,
  TWD: 3.855767,
  AUD: 0.17946,
  NZD: 0.196569,
  IDR: 1912.517634,
};

const TWExchangeRates = {
  EUR: 0.030377,
  USD: 0.03309,
  HKD: 0.259038,
  TWD: 1,
  AUD: 0.046512,
  NZD: 0.050956,
  IDR: 496.039919,
};

const HKCurrency = 'HKD';
const TWCurrency = 'TWD';

const formatCurrency = (data: MoneyV2) => {
  // const {
  //   country: {isoCode},
  // } = useLocalization();
  const currencySettings = React.useContext(GlobalContext);

  if (!currencySettings) {
    return;
  }
  // fx.base = isoCode === 'TW' ? TWCurrency : HKCurrency;
  // fx.rates = isoCode === 'TW' ? TWExchangeRates : HKExchangeRates;

  fx.base = currencySettings.baseCurrency;
  fx.rates = currencySettings.exchangeRates;
  return fx.convert(data.amount, {
    from: currencySettings?.baseCurrency ?? 'HKD',
    to: data.currencyCode,
  });
};

export default formatCurrency;
